package com.cybersoftsolution.cybersoftsolutionweb.components.sections


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.cards.WorkFlowCard
import com.cybersoftsolution.cybersoftsolutionweb.components.carousel.MyVerticalCarousel
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.ContentLayout
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.WorkFlow
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px


@Composable
fun WorkFlowSection(
    pageSection: PageSection,
    workFlow:List<WorkFlow>,
    sectionModifier: Modifier = Modifier,
    contentModifier: Modifier = Modifier,
    title: String? = null,
) {

    val breakpoint = rememberBreakpoint()
//    val fixWithInPercent:Int by remember { mutableStateOf( floor(100f / services.size).toInt()) }
//    var responsiveWidth:Int by remember { mutableStateOf( 500 ) }

    var mutableWorkFlow by remember { mutableStateOf(workFlow) }

    //Pause slideShow when a service is selected
    var pausedSlideShow:Boolean by remember { mutableStateOf( false ) }
    LaunchedEffect(mutableWorkFlow){
        pausedSlideShow = mutableWorkFlow.any { it.selected }
    }


    ContentLayout(
        title = title,
        pageSection = pageSection,
        sectionModifier = sectionModifier,
        contentModifier = contentModifier
    ){


        if (!isDesktop()) {

            MyVerticalCarousel(
                modifier = Modifier
                    .fillMaxWidth(),
                id = pageSection.id+"carousel",
                elements = mutableWorkFlow,
                slideShow = false,
                pauseSlideShow = pausedSlideShow,
                onForceToContinue = {
                    val updateServices = mutableWorkFlow.map { it.copy(selected = false)}
                    mutableWorkFlow = updateServices
                },
                previewButtonText = "\u279c",
                nextButtonText = "\u279c",
                initIndex = 1 + mutableWorkFlow.indexOfFirst { it.selected },
//                    onResponsiveWidthChange = { responsiveWidthFromCarousel ->
//                        responsiveWidthFromCarousel?.let { responsiveWidth = it }
//                    }
                useCustomNavigator = true,
                navigatorItem = { navigatorItem ->
                    Image(
                        width = 40,
                        modifier = Modifier
//                        .fillMaxWidth(50.percent)

                            .backgroundColor(Theme.Withe.rgb)
                            .aspectRatio(1F)
                            .borderRadius(365.px)
                            .border {
                                color(Theme.HalfBlack.rgb)
                                width(0.px)
                                style(LineStyle.Solid)
                            }
                            .objectFit(ObjectFit.Cover),
                        src = navigatorItem.image,
                    )
                }
            ) { workflow ->

                WorkFlowCard(
                    onCardClick = {
                        val updateServices = mutableWorkFlow.map {
                            if (it.id == workflow.id) {
                                it.copy(selected = !it.selected)
                            } else {
                                it.copy(selected = false)
                            }
                        }
                        mutableWorkFlow = updateServices
                    },
                    selected = workflow.selected,
                    id = workflow.id+"CardInCarousel",
                    workFlowName = workflow.name,
                    workFlowDescription = workflow.description,
                    workFlowItems = workflow.items,
                    workFlowItemsImage = workflow.image,
                    onButtonClick = {},
                    buttonText = "",
                ){

                }
            }



        }
        else {
            pausedSlideShow = false

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                mutableWorkFlow.forEach { workflow ->


                    WorkFlowCard(
                        modifier = Modifier
                            .margin(leftRight = 8.px),
                        onCardClick = {
                            val updateServices = mutableWorkFlow.map {
                                if (it.id == workflow.id) {
                                    it.copy(selected = !it.selected)
                                } else {
                                    it.copy(selected = false)
                                }
                            }
                            mutableWorkFlow = updateServices
                        },
                        selected = workflow.selected,
                        id = workflow.id+"CardInRow",
                        workFlowName = workflow.name,
                        workFlowDescription = workflow.description,
                        workFlowItems = workflow.items,
                        workFlowItemsImage = workflow.image,
                        onButtonClick = {},
                        buttonText = "",
                    ){

                    }




                }


            }

        }


    }


}